// TODO: insert tag manager id
let cookieInformationElem;

function acceptCookies() {
  console.log('acceptCookies');
  setCookie('acceptcookies', '1');
  if (process.env.ENV === 'production') {
    var _paq = (window._paq = window._paq || []);
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
      var u = '//analytics.1337.camp/';
      _paq.push(['setTrackerUrl', u + 'matomo.php']);
      _paq.push(['setSiteId', '1']);
      var d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = u + 'matomo.js';
      s.parentNode.insertBefore(g, s);
    })();
  } else if (process.env.ENV === 'staging') {
    // TODO: replace with staging tag manager snippet
  }
  hideCookieBanner();
}

function hideCookieBanner() {
  setCookie('hidecookieinfo', '1');
  cookieInformationElem.style.display = 'none';
}

function setCookie(name, value) {
  let d = new Date();
  d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = `${name}=${value};path=/;` + expires;
}

function disagreeCookies() {
  console.log('disagreeCookies');
  hideCookieBanner();
}

function resetCookies() {
  if (confirm('Cookie-Einstellungen zurücksetzen?')) {
    disagreeCookies();
    document.cookie = `acceptcookies=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    setCookie('hidecookieinfo', '0');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const resetCookiesBtns = document.querySelectorAll('.reset-cookies-btn');
  if (resetCookiesBtns) {
    resetCookiesBtns.forEach(el => {
      el.addEventListener('click', resetCookies);
    });
  }
});

// Setup cookiebanner events
document.addEventListener('DOMContentLoaded', function() {
  cookieInformationElem = document.querySelector('#cookies-information');
  if (cookieInformationElem) {
    // Logic to only activate selected cookies
    cookieInformationElem.querySelector('#btn-accept-selected').addEventListener('click', () => {
      const checkboxEls = cookieInformationElem.querySelectorAll('.checkboxes-container input');
      const allowTracking = !!Array.from(checkboxEls).find(el => el.value === 'tracking' && el.checked);
      if (allowTracking) {
        acceptCookies();
      } else {
        disagreeCookies();
      }
    });
    cookieInformationElem.querySelector('#btn-accept-all').addEventListener('click', acceptCookies);
    // Show popup if user is trying to unselect the required option
    cookieInformationElem.querySelector('label[for="required-cookies"]').addEventListener('click', function() {
      alert(this.title);
    });

    if (document.cookie.indexOf('hidecookieinfo=1') === -1) {
      const path = window.location.pathname.split('/');
      if (path.includes('privacy') || path.includes('datenschutz')) {
        cookieInformationElem.style.display = 'none';
      } else {
        cookieInformationElem.style.display = 'flex';
      }
    } else {
      if (document.cookie.indexOf('acceptcookies=1') !== -1) {
        acceptCookies();
      } else {
        disagreeCookies();
      }
    }
  }
});
